export default "__VITE_ASSET__99ab1f3f__"